/*
 * File: Orders.js
 * Project: mp-mobile-app
 *
 * Created by Rob on 03/07/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Renders a dashboard card with orders data
 */
import React from "react";
import PropTypes from "prop-types";
import OrdersIcon from "@material-ui/icons/AssignmentTurnedIn";
import DashboardCard from "./DashboardCard";

const Orders = ({ loading, ordersCount }) => (
  <DashboardCard
    loading={loading}
    label="Orders Open"
    icon={<OrdersIcon className="dashboard-card-icon" />}
    number={ordersCount}
    url="/orders"
  />
);

Orders.propTypes = {
  loading: PropTypes.bool,
  ordersCount: PropTypes.number
};

export default Orders;
